<script>
  let {
    processing = false,
    label = 'Save',
    loadingLabel = 'Saving…',
    class: buttonClass = 'btn-primary',
    full = true
  } = $props()
</script>

<button type="submit" class="btn {buttonClass}" class:w-full={full} disabled={processing}>
  {#if processing}
    <span class="loading loading-spinner loading-sm"></span>
    {loadingLabel}
  {:else}
    {label}
  {/if}
</button>
